module.exports = __webpack_public_path__ + "static/media/beam.bc93dd30.svg";